export enum FeatureFlagKey {
  // Add your FeatureFlag keys here..
  // Keep alphabetized!!
  ACCEPT_CHALLENGE_USE_K8S_AUTH_SERVICE = 'accept_challenge_use_k8s_auth_service',
  ACCOUNT_LOOKUP_USE_K8S_AUTH_SERVICE = 'account_lookup_use_k8s_auth_service',
  ADDRESS_CONFIRMATION_FEATURE = 'address_confirmation_feature',
  AMPLITUDE_REPLAY = 'session_replay',
  BELIEVE_DAY_0_M1 = 'believe_day_0_m1',
  BELIEVE_DAY_0_M2 = 'believe_day_0_m2',
  BILL_SWITCH_FUNDING_ENABLE_AMOUNT_ALERT = 'bill_switch_funding_enable_amount_alert',
  BILL_SWITCH_PILOT = 'bill_switch_pilot',
  CRUISE_TEST = 'cruise_test_feature',
  DCF_ADDRESS_INPUT_ENABLED = 'dcf_address_input_enabled',
  ENABLE_90_DAYS_NEW_SPARKLE_TAG = 'enable_90_days_new_sparkle_tag',
  ENABLE_GD_BARCODE_KROGER = 'enable_gd_barcode_kroger',
  ENABLE_PAY_LATER = 'enable_pay_later',
  ENABLE_PAY_OVER_TIME = 'enable_pay_over_time',
  ENABLE_CLOUDFLARE_TURNSTILE_NATIVE = 'enable_cloudflare_turnstile_native',
  ENABLE_DYNAMIC_MAP_ENTRY_POINT = 'enable_dynamic_map_rewards_entry_point',
  ENCOURAGE_DD_AFTER_VA_SUCCESS = 'encourage_dd_after_va_success',
  ENABLE_LIGHTNING = 'enable_lightning',
  ENABLE_MAP_CLUSTER_MINIMIZED_PILLS = 'enable_map_cluster_minimized_pills',
  ENABLE_SELF_FUNDED_OFFERS = 'enable_self_funded_offers',
  ENABLE_VA_MANUAL_PAY_ACH = 'advance_manualpay_ach',
  ENABLE_HOME_REDESIGN_PHASE1 = 'enable_home_redesign_phase1',
  FORGOT_PASSWORD_USE_K8S_AUTH_SERVICE = 'forgot_password_use_k8s_auth_service',
  INITIATE_CHALLENGE_USE_K8S_AUTH_SERVICE = 'initiate_challenge_use_k8s_auth_service',
  LOGIN_USE_K8S_AUTH_SERVICE = 'login_use_k8s_auth_service',
  MIGRATE_V2A_OTP = 'migrate_v2a_otp',
  NON_ORGANIC_ATTRIBUTIONS_ENABLED = 'enable_non_organic_attributions_in_incentive_platform',
  ONBOARDING_VIDEO = 'onboarding_video',
  OTA_RELOAD_BANNER = 'ota_reload_banner',
  REACTIVATION_STANDARD_ONBOARDING = 'reactivation_standard_onboarding',
  REFRESH_TOKEN_TRADE_USE_K8S_AUTH_SERVICE = 'refresh_token_trade_use_k8s_auth_service',
  RENAME_LOCK_TO_FROZEN = 'rename_lock_to_frozen',
  RESEND_OTP_USE_K8S_AUTH_SERVICE = 'resend_otp_use_k8s_auth_service',
  RESET_PASSWORD_USE_K8S_AUTH_SERVICE = 'reset_password_use_k8s_auth_service',
  SELECT_CHALLENGE_USE_K8S_AUTH_SERVICE = 'select_challenge_use_k8s_auth_service',
  SIGNUP_USE_K8S_AUTH_SERVICE = 'signup_use_k8s_auth_service',
  UPDATE_BORROWING_POWER_PAGE = 'update_borrowing_power_page',
  UPDATE_BORROWING_POWER_PAGE_PHASE_2 = 'update_borrowing_power_page_phase_2',
  VA_DAY_0_DIRECT_DEPOSIT_PHASE_2 = 'va_day_0_direct_deposit_phase_2',
  V2A_WEB_SENDER_FLOW = 'enable_v2a_web_sender_flow',
  VERIFY_ATTRIBUTE_USE_K8S_AUTH_SERVICE = 'verify_attribute_use_k8s_auth_service',
  ENABLE_CUSTOMER_SERVICE_HOME_MAILING_ADDRESS = 'enable_customer_service_home_mailing_address',
  ENABLE_DECAGON_CHAT = 'enable_decagon_chat',
  ENABLE_LIGHTNING_JOURNEY_CONGRATS = 'enable_lightning_journey_congrats',
  ENABLE_GOOGLE_PAY_FUNDING = 'enable_google_pay_funding',
  ENABLE_LIGHTNING_DD = 'enable_lightning_dd',
  ENABLE_DECAGON_CHAT_SEND_BLOCK = 'enable_decagon_chat_send_block',
  ENABLE_ZELLE_PERSONALIZED_GUIDANCE = 'enable_zelle_personalized_guidance',
  FBIT_PILOT = 'fbit_pilot',
}

export enum ExperimentKey {
  // Add your Experiment keys here..
  CRUISE_TEST = 'cruise_test_experiment',
  DAY0_LCM_DISCLAIMER = 'day0_lcm_disclaimer',
  FUNDING_MENU_UPDATE = 'experiment_funding_menu_update',
  DD_INSTANT_SWITCH_INTRO_SCREEN = 'dd_instant_switch_intro_screen',
  DD_SETUP_PAGE_EXPERIMENT = 'dd_setup_page_experiment',
  FBIT_VA_ENTRY_POINT = 'fbit_va_entry_point',
  SIGNUP_PAGE_HEADER_TEST = 'Sign_Up_Page_Header_Test_Experiment',
}

export enum DynamicConfigurationKey {
  // Add your Dynamic Configuration keys here..
  SERVER_STATUS = 'server_status',
  AGREEMENT_ON_SIGNUP_SCREEN = 'phone_agreement_on_signup_screen',
}
